import { render, staticRenderFns } from "./ui-tooltip.vue?vue&type=template&id=352193b8&"
import script from "./ui-tooltip.vue?vue&type=script&lang=js&"
export * from "./ui-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./_ui-tooltip.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports